import { Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import { TEXT_VARIANTS } from '../../../../constants'

const useStyles = makeStyles((theme) => ({
  container: ({ adornment }) => ({
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
    marginBottom: adornment ? theme.spacing(2) : 0
  }),
  content: {
    textAlign: 'left',
    fontSize: '1.5rem'
  }
}))

const Title = ({ children, adornment, ...rest }) => {
  const classes = useStyles()
  return (
    <div className={classes.container} {...rest}>
      <Typography variant={TEXT_VARIANTS.h3} className={classes.content}>
        {children}
      </Typography>
      {adornment}
    </div>
  )
}

Title.propTypes = {
  children: PropTypes.node,
  adornment: PropTypes.node
}

export default Title
